import { Injectable } from "@angular/core";
import { ThermalAuth } from "./thermal-auth";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ThermalApi {

    private basePath: string = ""

    constructor(
        private http: HttpClient,
        private thermalAuth: ThermalAuth,
    ) { }

    public setBaseUrl(url: string) {
        this.basePath = url;
        this.thermalAuth.setBaseUrlThermal(url);
    }

    public request(method: string, model: string, func: string, params: any, contentType?: string, timeOut: number = 30000) {
        this.basePath = this.thermalAuth.getBaseUrlThermal();

        switch (method) {
            case 'GET':
                if (model == null || model == '') {
                    return this.http.get(`${this.basePath}/${func}?${new URLSearchParams(this._JSON2URL(params, false))}`, {}).toPromise();
                } else {
                    return this.http.get(`${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(params, false))}`, {}).toPromise();
                }
            case 'POST':
                if (model == null || model == '') {
                    return this.http.post(`${this.basePath}/${func}?`, params, {}).toPromise();
                } else {
                    return this.http.post(`${this.basePath}/${model}/${func}?`, params, {}).toPromise();
                }
        }
    }

    // public request(method: string, model: string, func: string, params: any, contentType?: string, timeOut: number = 30000) {
    //     this.basePath = this.thermalAuth.getBaseUrlThermal();
    //     this.http.setRequestTimeout(10.0);

    //     switch (method) {
    //         case 'GET':
    //             this.http.setDataSerializer('json');
    //             if (model == null || model == '') {
    //                 return this.http.get(`${this.basePath}/${func}?${new URLSearchParams(this._JSON2URL(params, false))}`, {}, {});
    //             } else {
    //                 return this.http.get(`${this.basePath}/${model}/${func}?${new URLSearchParams(this._JSON2URL(params, false))}`, {}, {});
    //             }
    //         case 'POST':
    //             this.http.setDataSerializer('multipart');
    //             if (model == null || model == '') {
    //                 return this.http.post(`${this.basePath}/${func}?`, params, {});
    //             } else {
    //                 return this.http.post(`${this.basePath}/${model}/${func}?`, params, {});
    //             }
    //     }
    // }

    private _JSON2URL(obj: any, parent: any) {
        const parts: any = [];
        for (const key in obj)
            parts.push(this._parseParam(key, obj[key], parent));
        return parts.join('&');
    }

    private _parseParam(key: string, value: any, parent: string) {
        let processedKey = parent ? parent + '[' + key + ']' : key;
        if (value && (<string>(typeof value) === 'object' || Array.isArray(value))) {
            return this._JSON2URL(value, processedKey);
        }
        return processedKey + '=' + value;
    }

}


// WEBPACK FOOTER //
// ./src/shared/thermal/thermal-api.ts